/**
 * WizLocationSelect 省市区选择组件Demo
 * @author jzhu
 * @date 2020-05-28
 */

import React from 'react'
import { component_tool } from '@/tool'
const { WizComponent, WizCard, WizRow, WizCol, WizForm, WizLocationSelect } = component_tool

export default class WizLocationSelectDemo extends WizComponent {

    _onSubmit = (values, record) => {
        console.log('demo values --> ', values)
        console.log('demo record --> ', record)
    }

    _columns = () => {
        return [
            {
                title: '城市',
                name: 'city',
                dataIndex: 'city',
                formItem: {
                    type: 'diy',
                    diy: WizLocationSelect,
                    optionType: 'city',
                    rules: [{ required: true, message: '请选择城市' }]
                }
            },
            {
                title: '省市',
                name: 'provinceAndCity',
                dataIndex: 'provinceAndCity',
                formItem: {
                    type: 'diy',
                    diy: WizLocationSelect,
                    rules: [{ required: true, message: '请选择省市' }]
                }
            },
            {
                title: '省份',
                name: 'province',
                dataIndex: 'province',
                formItem: {
                    type: 'diy',
                    diy: WizLocationSelect,
                    optionType: 'province',
                    rules: [{ required: true, message: '请选择省份' }]
                }
            },
            {
                title: '区县',
                name: 'region',
                dataIndex: 'region',
                formItem: {
                    type: 'diy',
                    diy: WizLocationSelect,
                    optionType: 'region',
                    valueType: 'all',
                    showSearch: true,
                    rules: [{ required: true, message: '请选择区县' }]
                }
            }
        ]
    }

    render() {
        let formProps = {
            ref: 'form',
            record: { 
                city: '上海市', 
                provinceAndCity: '杭州市' 
            },
            columns: this._columns(),
            onSubmit: this._onSubmit,
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            }
        }
        return (
            <>
                <WizCard title='省市区选择组件'>
                    <WizRow style={{ marginTop: 30, marginBottom: 30 }}>
                        <WizCol span={10} offset={2}>
                            <WizLocationSelect placeholder='请选择省份' optionType='province' />
                        </WizCol>
                        <WizCol span={10} offset={2}>
                            <WizLocationSelect placeholder='请选择城市' optionType='city' />
                        </WizCol>
                    </WizRow>
                    <WizRow style={{ marginTop: 30, marginBottom: 30 }}>
                        <WizCol span={10} offset={2}>
                            <WizLocationSelect placeholder='请选择省市' />
                        </WizCol>
                        <WizCol span={10} offset={2}>
                            <WizLocationSelect placeholder='请选择省市区' optionType='region' />
                        </WizCol>
                    </WizRow>
                </WizCard>
                <WizCard title='FORM省市区选择'>
                    <WizForm {...formProps} />
                </WizCard>
            </>
        )
    }
}